import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';

export default function initImageSlider() {
    // Arrangements slider based on swiper
    let slidesPerView = 2;

    if (screen.width < 768) {
        slidesPerView = 1;
    }

    new Swiper('.image-swiper', {
        slidesPerView,
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slideClass: 'cmeleon-block-content',
        loopFillGroupWithBlank: false,
    });
}
